import React, { memo } from 'react';
import { XCircleIcon } from 'lucide-react';
export function FailedApproaches() {
  const failures = ['Las listas de tareas tradicionales fallan porque tu cerebro las trata como "paisaje" o ruido visual después de 24 horas.', 'Las apps de productividad añaden más distracciones digitales de las que resuelven.', 'Intentar "esforzarse más" no arregla una deficiencia biológica de dopamina ni crea memoria donde no la hay.', 'Dividir las tareas al 50/50 es injusto cuando una tarea drena 10 veces más energía a un cerebro neurodiverso que a uno típico.'];
  return <section className="py-16 md:py-24 bg-gradient-to-b from-[#0f172a] to-[#1e293b]" data-id="element-3">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-4">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-5">
          Por Qué Lo Que Has Intentado No Funciona
        </h2>

        <div className="space-y-4" data-id="element-6">
          {failures.map((failure, index) => <div key={index} className="flex items-start gap-4 p-6 bg-slate-900/50 rounded-2xl border border-red-900/30 hover:border-red-500/30 transition-colors" data-id="element-7">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-8" />
              <p className="text-lg text-slate-300 leading-relaxed" data-id="element-9">
                {failure}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}